"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useInHouseMetrics: () => useInHouseMetrics,
  usePostHogAnalytics: () => usePostHogAnalytics
});
module.exports = __toCommonJS(src_exports);

// src/hooks/useInHouseMetrics.ts
var import_state = require("state");
var import_useutm = require("@gojiraf/useutm");
var { REACT_APP_INHOUSE_METRICS_URL } = process.env;
if (!REACT_APP_INHOUSE_METRICS_URL) {
  console.error("REACT_APP_INHOUSE_METRICS_URL is not defined");
}
var MetricsMap = {
  0: [],
  1: [
    "cart-initialized",
    "chat-confirm-form",
    "schedule-confirm-form",
    "checkout-started",
    "checkout-from-cart",
    "checkout-from-catalog",
    "checkout-from-pdp",
    "checkout-from-quick-buy",
    "decode-video-error",
    "redirect-click-confirm-button",
    "event-entered-live",
    "event-user-active",
    "event-accept-tyc",
    "event-reject-tyc",
    "event-send-satisfaction-survey",
    "click-share-button",
    "click-view-more-integration-light",
    "add-to-calendar-button",
    "product-add-to-cart",
    "product-click-detail-button",
    "product-click-detail-card",
    "product-click-detail-image",
    "product-featured"
  ],
  2: ["message-like", "copy-code", "product-click-catalog"],
  3: []
};
var sendMetric = (eventId, storeId, eventType) => {
  fetch(`${REACT_APP_INHOUSE_METRICS_URL}/api/metrics`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    keepalive: true,
    body: JSON.stringify({ eventId, storeId, eventType })
  });
};
var useInHouseMetrics = () => {
  const { store, event } = (0, import_state.useStore)((storeState) => storeState);
  const { utmMedium } = (0, import_useutm.getURLParams)();
  const { isAudience } = (0, import_useutm.useUtm)(utmMedium);
  const trackEvent = (eventAction) => {
    if (!isAudience) return;
    try {
      if (!store || !REACT_APP_INHOUSE_METRICS_URL || !event) return;
      const logsLevelKey = store.storeConfigurations.logsLevel;
      if (logsLevelKey === 3) {
        sendMetric(event == null ? void 0 : event.eventId, store.id, eventAction);
        return;
      }
      let eventsToTrack = [];
      for (let i = 0; i <= logsLevelKey; i++) {
        eventsToTrack = [...eventsToTrack, ...MetricsMap[i]];
      }
      const shouldTrack = eventsToTrack.some((e) => eventAction.startsWith(e));
      if (shouldTrack) {
        sendMetric(event == null ? void 0 : event.eventId, store.id, eventAction);
      }
    } catch (error) {
      console.error("Error tracking event with PostHog:", error);
    }
  };
  return {
    trackEvent
  };
};

// src/hooks/usePostHogAnalytics.ts
var import_state2 = require("state");
var import_posthog_js = __toESM(require("posthog-js"));
var import_auth = require("@gojiraf/auth");
var { REACT_APP_POSTHOG_KEY } = process.env;
if (!REACT_APP_POSTHOG_KEY) {
  throw new Error("REACT_APP_POSTHOG_KEY is not defined");
}
var POSTHOG_URL = "https://us.i.posthog.com";
var PostHogMap = {
  0: [],
  1: [
    "cart-initialized",
    "chat-confirm-form",
    "schedule-confirm-form",
    "chat-message-sent",
    "checkout-started",
    "checkout-from-cart",
    "checkout-from-catalog",
    "checkout-from-pdp",
    "checkout-from-quick-buy",
    "decode-video-error",
    "redirect-click-confirm-button",
    "event-entered-live",
    "event-user-active",
    "event-accept-tyc",
    "event-reject-tyc",
    "event-send-satisfaction-survey",
    "click-share-button",
    "click-view-more-integration-light",
    "add-to-calendar-button",
    "product-add-to-cart",
    "product-click-detail-button",
    "product-click-detail-card",
    "product-click-detail-image",
    "product-featured",
    "error-tencent-player",
    "error-wake-unlock",
    "error-wake-lock",
    "live-network-blocked"
  ],
  2: ["message-like", "copy-code", "product-click-catalog"],
  3: []
};
var PLAYBACK_FAILURE_EVENTS = [
  "live-webrtc-unreachable",
  "live-hls-stalled",
  "live-hls-unreachable",
  "live-hls-engine-dead"
];
PostHogMap[1] = [...PostHogMap[1], ...PLAYBACK_FAILURE_EVENTS];
var usePostHogAnalytics = () => {
  const { store, event: eventData } = (0, import_state2.useStore)((storeState) => storeState);
  const { user } = (0, import_auth.useAuth)();
  const postHogTrackEvent = (event, options) => {
    try {
      if (!store) return;
      const logsLevelKey = store.storeConfigurations.logsLevel;
      if (logsLevelKey === 3) {
        import_posthog_js.default.capture(event, __spreadValues({
          storeId: store.id,
          eventId: eventData == null ? void 0 : eventData.eventId,
          eventCategory: eventData == null ? void 0 : eventData.category,
          userId: user.id
        }, options));
        return;
      }
      let eventsToTrack = [];
      for (let i = 0; i <= logsLevelKey; i++) {
        eventsToTrack = [...eventsToTrack, ...PostHogMap[i]];
      }
      const shouldTrack = eventsToTrack.some((e) => event.startsWith(e));
      if (shouldTrack) {
        const properties = __spreadValues({
          storeId: store.id,
          eventId: eventData == null ? void 0 : eventData.eventId,
          eventCategory: eventData == null ? void 0 : eventData.category,
          userId: user.id,
          companyId: store.company.id
        }, options);
        import_posthog_js.default.capture(event, properties);
      }
    } catch (error) {
      console.error("Error tracking event with PostHog:", error);
    }
  };
  const postHogTrackPageView = (options) => {
    if (store && store.storeConfigurations.logsLevel === 0) return;
    try {
      const properties = __spreadValues({
        $current_url: window.location.href,
        storeId: store == null ? void 0 : store.id,
        eventId: eventData == null ? void 0 : eventData.eventId,
        eventCategory: eventData == null ? void 0 : eventData.category,
        userId: user == null ? void 0 : user.id,
        companyId: store == null ? void 0 : store.company.id
      }, options);
      import_posthog_js.default.capture("$pageview", properties);
    } catch (error) {
      console.error("Error tracking page view with PostHog:", error);
    }
  };
  const postHogTrackPageLeave = (url = window.location.href, timeOnPage, options) => {
    if (store && store.storeConfigurations.logsLevel === 0) return;
    try {
      const properties = __spreadValues({
        $current_url: url,
        timeOnPage,
        storeId: store == null ? void 0 : store.id,
        eventId: eventData == null ? void 0 : eventData.eventId,
        eventCategory: eventData == null ? void 0 : eventData.category,
        userId: user == null ? void 0 : user.id,
        companyId: store == null ? void 0 : store.company.id
      }, options);
      import_posthog_js.default.capture("$pageleave", properties);
    } catch (error) {
      console.error("Error tracking page leave with PostHog:", error);
    }
  };
  const initPostHog = () => {
    import_posthog_js.default.init(REACT_APP_POSTHOG_KEY, {
      api_host: typeof window !== "undefined" ? `${window.location.origin}/ingest` : POSTHOG_URL,
      ui_host: POSTHOG_URL,
      autocapture: false,
      capture_pageview: false,
      capture_exceptions: false,
      capture_pageleave: false,
      persistence: "localStorage",
      debug: process.env.NODE_ENV === "development",
      session_idle_timeout_seconds: 60 * 60,
      // 60 minutes
      disable_session_recording: true
    });
  };
  const postHogRegister = (properties) => {
    try {
      import_posthog_js.default.register(properties);
    } catch (error) {
      console.error("Error registering PostHog super properties:", error);
    }
  };
  return {
    initPostHog,
    postHogTrackEvent,
    postHogTrackPageView,
    postHogTrackPageLeave,
    postHogRegister
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useInHouseMetrics,
  usePostHogAnalytics
});
